"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSummaryTimelineComponents = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var PageStatusIcon_1 = require("@CommonFrontend/Project/PageStatusIcon");
var Engagement_1 = require("Common/Engagement");
var Timeline_1 = require("Analytics/Page/Components/Timeline/Timeline");
var UseSummaryTimeline_1 = require("./UseSummaryTimeline");
var PageStatusEventCard_1 = require("./PageStatusEventCard");
var EngagementChangedEventCard_1 = require("./EngagementChangedEventCard");
var PageViewedEventCard_1 = require("./PageViewedEventCard");
var PageAcceptedTimelineCards_1 = require("Analytics/Page/Components/Timeline/PageAcceptedTimelineCards");
function useSummaryTimelineComponents(_a) {
    var pageId = _a.pageId, timeParams = _a.timeParams, openSession = _a.openSession;
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var summaryTimelineData = (0, UseSummaryTimeline_1.useSummaryTimeline)(pageId, timeParams).summaryTimelineData;
    function onOpenSessionClick(viewer, pageViewId) {
        openSession(viewer, pageViewId);
        serverTelemetry.sendPageAnalyticsTelemetry({
            eventName: event_tracker_types_1.EventName.PageAnalyticsSessionViewViewed,
            eventOrigin: event_tracker_types_1.EventOrigin.QwilrCard,
        });
    }
    var _b = (0, Timeline_1.useTimeline)({
        timelineData: summaryTimelineData,
        timeZone: timeParams.timeZone,
        getEventIcon: getEventIcon,
        renderEventCard: function (data) { return renderEventCard(data, timeParams.timeZone, onOpenSessionClick); },
    }), timelineComponent = _b.timelineComponent, timelineFilterButtons = _b.timelineFilterButtons;
    return { timelineComponent: timelineComponent, timelineFilterButtons: timelineFilterButtons };
}
exports.useSummaryTimelineComponents = useSummaryTimelineComponents;
function renderEventCard(rowData, timeZone, onOpenSessionClick) {
    switch (rowData.eventData.eventType) {
        case "pageStatus":
            return react_1.default.createElement(PageStatusEventCard_1.PageStatusEventCard, { eventData: rowData.eventData });
        case "engagementLevel":
            return react_1.default.createElement(EngagementChangedEventCard_1.EngagementChangedEventCard, { eventData: rowData.eventData });
        case "pageView":
            return react_1.default.createElement(PageViewedEventCard_1.PageViewedEventCard, { eventData: rowData.eventData, onOpenSessionClick: onOpenSessionClick });
        case "Page Accepted":
            return react_1.default.createElement(PageAcceptedTimelineCards_1.PageAcceptedTimelineCard, { interactionEventData: rowData.eventData, timeZone: timeZone });
        case "Page Partially Accepted":
            return react_1.default.createElement(PageAcceptedTimelineCards_1.PagePartiallyAcceptedTimelineCard, { interactionEventData: rowData.eventData, timeZone: timeZone });
    }
}
function getEventIcon(_a) {
    var eventData = _a.eventData;
    switch (eventData.eventType) {
        case "pageStatus":
            if (eventData.changeSource === Types_1.PageStateChangeSource.PageCreation) {
                return react_1.default.createElement(icons_1.Page, null);
            }
            else {
                return react_1.default.createElement(PageStatusIcon_1.PageStatusIcon, { status: eventData.status });
            }
        case "engagementLevel":
            return react_1.default.createElement(Engagement_1.EngagementIcon, { engagementLevel: eventData.engagementLevel });
        case "pageView":
            return react_1.default.createElement(icons_1.Preview, { color: "default" });
        case "Page Partially Accepted":
        case "Page Accepted":
            if (eventData.eSigned) {
                return react_1.default.createElement(icons_1.BlockAcceptEsign, null);
            }
            else {
                return react_1.default.createElement(icons_1.BlockAccept, null);
            }
    }
}
